import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { CustomerResponse } from '@/types/apps/customer.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface CustomerServiceGraphQLInterface {}

type CustomerListResponse = GqlListResponse<CustomerResponse>;

export class CustomerGraphQLService
    extends BaseService
    implements CustomerServiceGraphQLInterface
{
    public getEntityName(): string {
        return 'customer';
    }

    public getFields(): Record<string, any> {
        return {
            address: true,
            code: true,
            email: true,
            id: true,
            leadTechnicianId: true,
            name: true,
            phoneNumber: true,
            longitude: true,
            deviceCount: true,
            description: true,
            latitude: true,
            createdDate: true,
            customerAccounts: {
                appUserId: true,
                createdBy: true,
                createdDate: true,
                customerId: true,
                deletedAt: true,
                deletedBy: true,
                id: true,
                isDeleted: true,
                modifiedBy: true,
                modifiedDate: true,
                appUser: {
                    email: true,
                    fullname: true,
                    phoneNumber: true,
                    userName: true,
                    id: true,
                },
            },
        };
    }

    public async index(query: string): Promise<CustomerListResponse> {
        return this.fetchGqlList<CustomerListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('customer', {
            userId: this.getQueryById(),
        });
    }
}
